import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/build/xendora/react-timer/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import ReactTimer from '../src/index';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "examples"
    }}>{`Examples`}</h1>

    <h2 {...{
      "id": "incremental-timer"
    }}>{`Incremental timer`}</h2>
    <Playground __position={0} __code={'<ReactTimer\n  start={0}\n  end={value => value === 30}\n  onEnd={value => console.log(\'ENDED WITH VALUE\', value)}\n  onTick={value => value + 1}\n>\n  {time => <div>{time}</div>}\n</ReactTimer>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      ReactTimer
    }} mdxType="Playground">
    <ReactTimer start={0} end={value => value === 30} onEnd={value => console.log('ENDED WITH VALUE', value)} onTick={value => value + 1} mdxType="ReactTimer">
        {time => <div>{time}</div>}
    </ReactTimer>
    </Playground>
    <h2 {...{
      "id": "decremental-timer"
    }}>{`Decremental timer`}</h2>
    <Playground __position={1} __code={'<ReactTimer\n  start={30}\n  end={value => value < 25}\n  onEnd={value => console.log(\'ENDED WITH VALUE\', value)}\n  onTick={value => value - 1}\n>\n  {time => <div>{time}</div>}\n</ReactTimer>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      ReactTimer
    }} mdxType="Playground">
    <ReactTimer start={30} end={value => value < 25} onEnd={value => console.log('ENDED WITH VALUE', value)} onTick={value => value - 1} mdxType="ReactTimer">
        {time => <div>{time}</div>}
    </ReactTimer>
    </Playground>
    <h2 {...{
      "id": "infinite-timer"
    }}>{`Infinite timer`}</h2>
    <Playground __position={2} __code={'<ReactTimer\n  start={0}\n  end={() => false}\n  onEnd={value => console.log(\'ENDED WITH VALUE\', value)}\n  onTick={value => value + 1}\n>\n  {time => <div>{time}</div>}\n</ReactTimer>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      ReactTimer
    }} mdxType="Playground">
    <ReactTimer start={0} end={() => false} onEnd={value => console.log('ENDED WITH VALUE', value)} onTick={value => value + 1} mdxType="ReactTimer">
        {time => <div>{time}</div>}
    </ReactTimer>
    </Playground>
    <h2 {...{
      "id": "basic-clock"
    }}>{`Basic Clock`}</h2>
    <Playground __position={3} __code={'<ReactTimer\n  start={0}\n  end={() => false}\n  onEnd={value => console.log(\'ENDED WITH VALUE\', value)}\n  onTick={value => value + 1}\n>\n  {() => new Date().toString()}\n</ReactTimer>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      ReactTimer
    }} mdxType="Playground">
    <ReactTimer start={0} end={() => false} onEnd={value => console.log('ENDED WITH VALUE', value)} onTick={value => value + 1} mdxType="ReactTimer">
        {() => new Date().toString()}
    </ReactTimer>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      